import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { PlaybookEventNames } from '../types';

type PlaybookEventPayload = Partial<
  Pick<TrackEventProperties, 'playbookId' | 'playId'>
>;
type EventName = keyof typeof PlaybookEventNames;

type FunctionNamesMap = {
  [K in EventName as `track${Capitalize<CamelCase<string & K>>}`]: (
    payload?: PlaybookEventPayload
  ) => void;
};

export const usePlaybookAnalytics = (location: string) => {
  const { trackEvent } = useAnalytics();

  const functionNameEntries = Object.keys(PlaybookEventNames).map(
    (eventName: EventName) => [
      eventName,
      `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}`,
    ]
  );

  return functionNameEntries.reduce<FunctionNamesMap>(
    (acc, [eventName, functionName]) => {
      acc[functionName as keyof FunctionNamesMap] = (
        payload?: PlaybookEventPayload
      ) => {
        trackEvent(PlaybookEventNames[eventName], {
          ...payload,
          location,
        });
      };
      return acc;
    },
    {} as FunctionNamesMap
  );
};
